import {
    Button,
    HorizontalContainer,
    Modal,
    Paragraph,
    VerticalContainer,
} from '@/components';
import { InfoIcon } from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';

type ConfirmModalProps = {
    onActionClick: () => void;
    onCancelClick: () => void;
    cancelClickText?: string;
    actionClickText?: string;
    text: string;
    isDisabled?: boolean;
};
export const ConfirmModal = ({
    onActionClick,
    onCancelClick,
    cancelClickText,
    actionClickText,
    text,
    isDisabled = false,
}: ConfirmModalProps) => {
    return (
        <Modal onClose={onCancelClick}>
            <VerticalContainer spacing="xl">
                <VerticalContainer>
                    <InfoIcon variant="default" />
                    <Paragraph content={text} className="m-0" />
                </VerticalContainer>
                <HorizontalContainer className="justify-end">
                    <Button
                        variant="ghost"
                        onClick={onCancelClick}
                        disabled={isDisabled}
                    >
                        {cancelClickText ?? R.Cancel}
                    </Button>
                    <Button onClick={onActionClick} disabled={isDisabled}>
                        {actionClickText ?? R.YesExit}
                    </Button>
                </HorizontalContainer>
            </VerticalContainer>
        </Modal>
    );
};
